import { EnterpriseDemoRequestMode } from "Services/API/API";

export const trackLeadCaptureForm = (captureMode: EnterpriseDemoRequestMode, actionName: string, attempt = 0) => {
   let formTypeName: string | null = null;
   switch (captureMode) {
      case EnterpriseDemoRequestMode.Enterprise:
      case EnterpriseDemoRequestMode.Workplace:
         formTypeName = "enterprise";
         break;
      case EnterpriseDemoRequestMode.HP:
         formTypeName = "general";
         break;
      case EnterpriseDemoRequestMode.CareersInline:
      case EnterpriseDemoRequestMode.WorkplaceInline:
         formTypeName = "onpage";
         break;
      default:
         break;
   }
   if (typeof ga == "function") {
      if (formTypeName) {
         ga("send", "pageview", { "page": `/vpv/lead-capture/${formTypeName}/${actionName}` });
      }
   } else if (attempt < 3) {
      setTimeout(function () {
         trackLeadCaptureForm(captureMode, actionName, ++attempt);
      }, 700);
   }
};